import { Map as ImmutableMap } from 'immutable';

import {
  REPORT_RESET,
  REPORT_SUBMIT_FAIL,
  REPORT_SUBMIT_REQUEST,
  REPORT_SUBMIT_SUCCESS,
} from '../actions/reports';

const initialState = ImmutableMap({
  isSubmitting: false,
  isSubmitted: false,
  error: null,
  report: null,
});

export default function reports(state = initialState, action) {
  switch(action.type) {
  case REPORT_RESET:
    return initialState;
  case REPORT_SUBMIT_REQUEST:
    return state.withMutations(map => {
      map.set('isSubmitting', true);
      map.set('isSubmitted', true);
      map.set('error', null);
    });
  case REPORT_SUBMIT_SUCCESS:
    return state.withMutations(map => {
      map.set('isSubmitting', false);
      map.set('isSubmitted', true);
      map.set('report', action.report);
    });
  case REPORT_SUBMIT_FAIL:
    return state.withMutations(map => {
      map.set('isSubmitting', false);
      map.set('isSubmitted', false);
      map.set('error', action.error);
    });
  default:
    return state;
  }
}
